import { makeVar } from "shared/providers/apollo/apollo.package";

/**
 * Indicates just plain ID of currently selected property
 */
export const propertyIdVar = makeVar<string | null>(null);

export const resetPropertyIdVar = () => propertyIdVar(null);
